import React from 'react'
import Product from '../ProductDetail/Product'
const Kids = () => {
  return (
    <div>
   <Product url="kids"/>
    </div>
  )
}

export default Kids